import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbmProgressBarComponent } from '@app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations:[DbmProgressBarComponent],
    exports: [
        DbmProgressBarComponent, CommonModule
    ],
    entryComponents: [DbmProgressBarComponent]
})
export class DbmProgressBarModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.module.ts